import React, { useState, useEffect } from "react";
import PageHeader from "../PageHader/PageHeader";
import Tab from "../../Page/Tabs/Tab"
import ActionAreaCard from "../MySkills/Card"
import ProjetCard from "../MySkills/ProjectCard"
import Footer from "../Footer"
const Experience = (props) => {
  const [panel, setPanel] = useState()
  useEffect(() => {
   
    setPanel(1)
  }, []);
  const d = new Date();
  let year = d.getFullYear();
  const PanelRender = (data) => {
    setPanel(data)
  }
  return (
    <center>
      <PageHeader back="Back" text="Experience" />
        <Tab panel1={"Professional"} panel2={"Personal"} panelData={PanelRender}  />
        <div className={panel===1?"":"hidden"}>
        <div className="w-[90%] md:w-[80%] lg:w-[50%]">
          <ActionAreaCard/>
        </div>
        <div className="w-[90%]  md:w-[80%] lg:w-[50%] mt-8">
        <ProjetCard/>
        </div>
        </div>

        <div className="">
        {panel===2&& <div className="border-[2px] border-[#17A6DB] my-4 lg:ml-8 dark:border-[#30dada] lg:w-[50%]">
            <h3 className="text-[32px] font-bold text-[#17A6DB] dark:text-[#30dada]">
            I will be updating soon 😊.
            </h3>
            </div>
            }
        </div>
        <div className=" mt-[70px] md:mt-[40px] md:block lg:mt-[10px] ">
        <p className="text-[#17A6DB] dark:text-[#30dada] flex justify-center md:pb-0">
        Developed  and Design @{year} by Deepesh Kumar. 
        </p>
        <Footer />
      </div>
    </center>
  )
}

export default Experience